import React, { ReactElement } from 'react';
import { Jobsite } from 'apollo/generated/client-operations';
import { ArrowRightIcon } from 'components/icons';
import { ModalFormContent } from 'components/form';
import { getJobsitesOptions } from 'containers/users/modals/utils';
import {
  getFormInputsHook,
  getFormDefaultValues,
} from './ChooseBadgeTypeModalContent.forms';
import { BadgeTypeOption, ChooseBadgeTypeData } from './types';

export interface ChooseBadgeTypeModalContentProps {
  setOpen: () => void;
  onAction: (jobsiteId: string, badgeType: BadgeTypeOption) => void;
  jobsites: Pick<Jobsite, 'jobsiteId' | 'name'>[];
}

export function ChooseBadgeTypeModalContent(
  props: ChooseBadgeTypeModalContentProps,
): ReactElement {
  const { onAction, setOpen, jobsites } = props;
  const [canContinue, setCanContinue] = React.useState(false);

  const onSubmit = (data: ChooseBadgeTypeData): void => {
    const { jobsiteId, badgeType } = data;
    onAction(jobsiteId.value, badgeType);
  };

  const { formInputs, defaultValues } = React.useMemo(() => {
    const jobsitesOptions = getJobsitesOptions(jobsites);
    return {
      jobsitesOptions,
      formInputs: getFormInputsHook({ jobsitesOptions, setCanContinue }),
      defaultValues: getFormDefaultValues({ jobsitesOptions }),
    };
  }, [jobsites]);

  return (
    <ModalFormContent
      setOpen={setOpen}
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Continue"
      actionIcon={ArrowRightIcon}
      actionButtonEnabled={canContinue}
    />
  );
}
